// year-wrapped 编辑器：year + stats(emoji/label/value/color) 增删。
import { useTranslation } from 'react-i18next'
import type { EditorContext } from '../_shared/types'
import type { WrappedData } from './types'
import { Field, TextInput, NumberInput, ColorField, Repeater, RemoveButton } from '../../components/editor-controls'

export function YearWrappedEditor({ data, update }: EditorContext) {
  const { t } = useTranslation()
  const d = data as unknown as WrappedData
  const stats = d.stats || []
  return (
    <>
      <Field label={t('editor.year')}>
        <NumberInput
          value={d.year ?? 2026}
          onChange={(v) => update((dd) => { dd.year = v })}
          style={{ width: 120 }}
        />
      </Field>
      <Field label={t('editor.statsCount', { count: stats.length })}>
        {stats.map((st, i) => (
          <div className="editable-item col" key={i}>
            <div className="editable-item">
              <TextInput
                value={st.emoji}
                placeholder="🏆"
                style={{ width: 56 }}
                onChange={(v) => update((dd) => { dd.stats[i].emoji = v })}
              />
              <TextInput
                value={st.label}
                placeholder={t('editor.tagPh')}
                style={{ flex: 2 }}
                onChange={(v) => update((dd) => { dd.stats[i].label = v })}
              />
              <RemoveButton onRemove={() => update((dd) => { dd.stats.splice(i, 1) })} />
            </div>
            <TextInput
              value={st.value}
              placeholder={t('editor.valuePh')}
              onChange={(v) => update((dd) => { dd.stats[i].value = v })}
            />
            <ColorField value={st.color} onChange={(c) => update((dd) => { dd.stats[i].color = c })} />
          </div>
        ))}
        <Repeater
          addLabel={t('editor.stat')}
          onAdd={() =>
            update((dd) => {
              dd.stats.push({ label: '', value: '', emoji: '📊', color: '#6366f1' })
            })
          }
        />
      </Field>
    </>
  )
}
